var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCirclePlus = function SvgCirclePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.5C15.2467 19.5 19.5 15.2467 19.5 10C19.5 4.75329 15.2467 0.5 10 0.5C4.75329 0.5 0.5 4.75329 0.5 10C0.5 15.2467 4.75329 19.5 10 19.5ZM11.1875 6.4375C11.1875 5.78166 10.6558 5.25 10 5.25C9.34416 5.25 8.8125 5.78166 8.8125 6.4375V8.8125H6.4375C5.78166 8.8125 5.25 9.34416 5.25 10C5.25 10.6558 5.78166 11.1875 6.4375 11.1875H8.8125V13.5625C8.8125 14.2183 9.34416 14.75 10 14.75C10.6558 14.75 11.1875 14.2183 11.1875 13.5625V11.1875H13.5625C14.2183 11.1875 14.75 10.6558 14.75 10C14.75 9.34416 14.2183 8.8125 13.5625 8.8125H11.1875V6.4375Z",
    fill: "#2698EB"
  })));
};
export default SvgCirclePlus;